import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./pagination.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./pagination.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
let PaginationComponent = class PaginationComponent {
    pages;
    pageSelected = new EventEmitter();
    currentPage;
    nextText = "Next";
    previousText = "Previous";
    constructor() {
    }
    ngOnInit() {
        this.currentPage = this.pages[0];
        if (this.pages.length === 0) {
            throw Error("There are no pages in the list of pages");
        }
    }
    isLastPage(currentPage) {
        return currentPage === this.pages[this.pages.length - 1];
    }
    isFirstPage(currentPage) {
        return currentPage === this.pages[0];
    }
    selectPage(page) {
        this.currentPage = page;
        this.pageSelected.emit(page);
    }
    selectNextPage() {
        if (this.isLastPage(this.currentPage)) {
            return;
        }
        this.selectPage(this.pages[this.pages.indexOf(this.currentPage) + 1]);
    }
    selectPrevious() {
        if (this.isFirstPage(this.currentPage)) {
            return;
        }
        this.selectPage(this.pages[this.pages.indexOf(this.currentPage) - 1]);
    }
    static ctorParameters = () => [];
    static propDecorators = {
        pages: [{ type: Input }],
        pageSelected: [{ type: Output }]
    };
};
PaginationComponent = __decorate([
    Component({
        selector: "app-pagination[pages]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], PaginationComponent);
export { PaginationComponent };
